import { render, staticRenderFns } from "./AcctAddMain.vue?vue&type=template&id=65170bd0&scoped=true&"
import script from "./AcctAddMain.vue?vue&type=script&lang=js&"
export * from "./AcctAddMain.vue?vue&type=script&lang=js&"
import style0 from "./AcctAddMain.vue?vue&type=style&index=0&id=65170bd0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65170bd0",
  null
  
)

export default component.exports